import { Button } from "@progress/kendo-react-buttons";
import { MdOutlineAccessTime } from "react-icons/md";
import { TbCreditCard } from "react-icons/tb";
import { TbShoppingCartCopy } from "react-icons/tb";
import { BsPlusSquareDotted } from "react-icons/bs";

import { LuWallet } from "react-icons/lu";
import selectExpenseIcon from '../../assets/select-expense.svg'
import billAllIcon from '../../assets/bill-all.svg'
import styles from "./Bills.module.scss";
import { GoPlusCircle } from "react-icons/go";

const VARIANT_CLASS = {
  blue: styles["bill-action-btn--blue"],
  green: styles["bill-action-btn--green"],
  peach: styles["bill-action-btn--peach"],
  purple: styles["bill-action-btn--purple"],
};

export const getBillActionButtons = ({
  setshowForm,
  setShowProfitGrid,
  setShowTemplatesGrid,
  setshowDisbForm,
  setAddNewDisb,
  setShowExpenseGrid,
  setShowMatterExpense,
}) => ({
  left: [
    {
      key: "select-time",
      label: "Select Time",
      icon: MdOutlineAccessTime,
      variant: "blue",
      onClick: () => setshowForm(true),
    },
    {
      key: "add-profit-cost",
      label: "Add Profit Cost",
      icon: GoPlusCircle,
      variant: "blue",
      onClick: () => setShowProfitGrid(true),
    },
    {
      key: "select-fixed-fee",
      label: "Select Fixed Fee",
      icon: LuWallet,
      variant: "blue",
      onClick: () => setShowTemplatesGrid(true),
    },
  ],
  right: [
    {
      key: "select-disb",
      label: "Select Disb.",
      icon: TbShoppingCartCopy,
      variant: "green",
      onClick: () => setshowDisbForm(true),
    },
    {
      key: "new-disb",
      label: "New Disb",
      icon: BsPlusSquareDotted,
      variant: "green",
      onClick: () => setAddNewDisb(true),
    },
    {
      key: "select-expense",
      label: "Select Expense",
      icon: TbCreditCard,
      variant: "peach",
      onClick: () => setShowMatterExpense(true),
    },
    {
      key: "add-expense",
      label: "Add Expense",
      icon: selectExpenseIcon,
      iconType: "image",
      variant: "peach",
      onClick: () => setShowExpenseGrid(true),
    },
    {
      key: "bill-all",
      label: "Bill All",
      icon: billAllIcon,
      iconType: "image",
      variant: "purple",
      disableWhenReadOnlyOnly: true,
    },
  ],
});

const BillActionButton = ({
  label,
  icon,
  iconType,
  variant,
  onClick,
  disabled,
}) => {
  const renderIcon = () => {
    if (iconType === "image" || typeof icon === "string") {
      return (
        <img
          src={icon}
          alt=""
          width={24}
          height={24}
          className="flex-shrink-0"
          draggable={false}
        />
      );
    }

    const Icon = icon;
    return <Icon size={24} color="#162EFF" className="flex-shrink-0" />;
  };

  return (
    <Button
      className={`d-inline-flex flex-column align-items-center justify-content-center border-0 shadow-none p-1 ${styles["bill-action-btn"]} ${VARIANT_CLASS[variant]}`}
      onClick={onClick}
      disabled={disabled}>
      {renderIcon()}
      <span
        className={`small fw-semibold text-center text-dark lh-sm d-flex align-items-center justify-content-center ${styles["bill-action-btn-label"]}`}>
        {label}
      </span>
    </Button>
  );
};

export default BillActionButton;
